export const aquatic = [
   "Eel",
   "Fantail Goldfish",
   "Freshwater Fish",
   "Goldfish",
   "Grouper",
   "Koi",
   "Marine Fish",
   "Mixed Breed",
   "Mullet",
   "Oranda Goldfish",
   "Oscar",
   "Pompano",
   "Rabbit Fish",
   "Seahorse",
   "Tilapia",
]
